/**
 * Today's Prompt Widget
 * Keeps the daily prompt and its countdown visible on every page, not just home.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { useTimeUntilMidnightCountdown } from '../../hooks/useTimeUntilMidnightCountdown';

const TodaysPromptWidget = ({ prompt }) => {
  const countdown = useTimeUntilMidnightCountdown(prompt?.nextRefresh);

  if (!prompt) return null;

  return (
    <div className="prompt-widget">
      <div className="widget-header">
        <div>
          <span className="widget-title">Today’s prompt</span>
          {countdown && (
            <div className="prompt-countdown"><Clock size={13} /> {countdown}</div>
          )}
        </div>
      </div>

      <p className="sidebar-prompt-text">
        {prompt.emotion} {prompt.connector} {prompt.setting}
      </p>

      <Link to="/" className="view-prompt-link">
        Read &amp; respond <ArrowRight size={14} />
      </Link>
    </div>
  );
};

export default TodaysPromptWidget;
